import type {
  CreateTag,
  TagResponseDto,
  TagWithUsageResponse,
  UpdateTag,
} from '@trellis/shared'

import { apiClient } from '@/lib/api-client'
import { request } from '@/lib/request'

export const listTags = () =>
  request<TagWithUsageResponse[]>(() => apiClient.api.tagsControllerListTags())

export const createTag = (data: CreateTag) =>
  request<TagResponseDto>(() => apiClient.api.tagsControllerCreateTag(data))

export const updateTag = (id: string, data: UpdateTag) =>
  request<TagResponseDto>(() => apiClient.api.tagsControllerUpdateTag({ id }, data))

export const deleteTag = (id: string) =>
  request<void>(() => apiClient.api.tagsControllerDeleteTag({ id }))
